import { render, staticRenderFns } from "./ListDivisionPage.vue?vue&type=template&id=42db59ae"
import script from "./ListDivisionPage.vue?vue&type=script&lang=js"
export * from "./ListDivisionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports